import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

const getTemplatesManagementState = (state: RootState) =>
  state.templatesManagement;

export const selectIsGettingTemplates = createSelector(
  [getTemplatesManagementState],
  ({ isGettingTemplates }) => isGettingTemplates
);

export const selectMeetingTemplates = createSelector(
  [getTemplatesManagementState],
  ({ meetingTemplates }) => meetingTemplates
);

export const selectAllAdminTemplates = createSelector(
  [getTemplatesManagementState],
  ({ allAdminTemplates }) => allAdminTemplates || []
);

export const selectActiveTemplate = createSelector(
  [getTemplatesManagementState],
  ({ activeTemplate }) => activeTemplate
);

export const selectIsCreatingTemplate = createSelector(
  [getTemplatesManagementState],
  ({ isCreatingTemplate }) => isCreatingTemplate
);

export const selectIsUpdatingTemplate = createSelector(
  [getTemplatesManagementState],
  ({ isUpdatingTemplate }) => isUpdatingTemplate
);

export const selectIsDeletingTemplate = createSelector(
  [getTemplatesManagementState],
  ({ isDeletingTemplate }) => isDeletingTemplate
);

export const selectActiveAdminTemplate = createSelector(
  [getTemplatesManagementState],
  ({ activeAdminTemplate }) => activeAdminTemplate
);
